import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Row, Col, Table } from "react-bootstrap";
import InputField from "../InputField/InputField";
import CheckboxField from "../CheckboxField/CheckboxField";
import SlectInputField from "../SlectInputField";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import "./ShippingAddress.styles.css";
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { commonGet} from "../../services/auth";
import RASelect from 'react-select/async';

const CorporateformSchema = Yup.object().shape({
  dellocname: Yup.string().min(2).required("Location name is required"),
  addr1: Yup.string().max(49,'Address 1 must be at most 50 characters'),
  addr2: Yup.string().max(49,'Address 2 must be at most 50 characters'),
  // postcode: Yup.number().required("Please enter your zip/postal code"),
  country: Yup.string().required("Country is required"),
  state: Yup.string(),//.required("State is required"),
  city: Yup.string(),//.required("City is required"),
  ptc: Yup.string().required("Contact Person is required"),
  phone: Yup.string().min(8, "Contact number must be of 8 digits").required("Please enter your contact number"),
});

const ShippingAddress = ({key}) => {
  const defaultAddressValue = {
    arnum: '',
    ccnum: '',
    dellocname: '',
    addr1: '',
    addr2: '',
    postcode: '',
    city: '',
    state: '',
    country: '',
    phone: '',
    uuid: '',
    ptc:''
  };

  const [initialValue, setInitialValue] = useState(defaultAddressValue);

  const [logedInUser, setLogedInUser] = useState(false);
  const [addressDetails, setAddressDetails] = useState(false); 
  const [addressEditDetails, setAddressEditDetails] = useState(false);
  const [applycorpsetting, setApplycorpsetting] = useState(false);
  const [costCenters, setCostCenters] = useState(false);    

  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [addNewPermission, setAddNewPermission] = useState(false);

  const getAccountDetails= async (arnum, role) => {
    var result=[];
    await Axios.get('/profile/location?arnum='+arnum)
    .then(function (response) {
    if(response.data && response.data?.data){
      if(response.data?.data?.addresses)setAddressDetails(response.data?.data?.addresses);
    }else{
      toast.error('Shipping Address data fetching failed !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      });
      return false;
    }})
    .catch(function (error) {
      setAddressDetails(false);
    });
  };

  const loadInitialdata = () => {
    const user=AuthVerify.getUser();
    if(user && user.role){
      if(user.applycorpsetting){
        setApplycorpsetting(user.applycorpsetting);
        getCostCenter(user.arnum)
      }
      getAccountDetails(user.arnum,user.role);
      setLogedInUser(user.role);
    }
  }
  
  async function getCostCenter (arnum) {
      // userDetails.arnum="ARM-90195171";
      await Axios.get(`/corporate/costcenter/${arnum}`)
      .then(async (costcenters) => {
          if (costcenters.status == 200 && costcenters.data?.data?.costcenters) {
            var dd=[];
            costcenters.data?.data?.costcenters.forEach(element => {
                dd.push({ label: element.ccname, value:  element.ccnum})
            });
            setCostCenters(dd);
          }else{
            setCostCenters([]);
          }
      })
  }

  useEffect(() => {
    loadInitialdata();
  }, [key])

  const handleEditAddress = (uuid=false,empty=false) =>{
    if(empty)return false;
    if(!uuid){
      setAddressEditDetails(defaultAddressValue);
      defaultAddressValue.arnum=AuthVerify.getUser().arnum;
      defaultAddressValue.uuid=Date.now();
      defaultAddressValue.ptc=defaultAddressValue.ptc??'';
      setInitialValue(defaultAddressValue);
    }
    else{
      var details=addressDetails.filter(i=>i.uuid === uuid)[0];
      setCountryValue(details.country);
      setStateValue(details.state);
      setCityValue(details.city);
      setAddressEditDetails(details);
      setInitialValue(details);
      handleCountryChange({target:{value:details.country}})
      setPostValue(details.postcode);
      setAddValue(details.addr1);
    }
  }

  const handleDeleteAddress = (e, item) =>{
    e.preventDefault();
    setAddressDetails(false);
    AuthVerify.deleteShippingAddress(item).then((data)=>{
      if (data){
        loadInitialdata();
      }
    });
  }

  const cancelEditAddress = () =>{
    setCountryValue(false);
    setStateValue(false);
    setCityValue(false);
    setAddressEditDetails(false);
    setDefaultValue(true);
    setPostValue(false);
    setAddValue(false);
  }

  const updateFormSubmitHandler = async (values) => {
    var val = {
      address:{
        arnum: values.arnum,
        dellocname: values.dellocname,
        addr1: addValue,
        addr2: values.addr2,
        postcode: postValue,
        city: cityValue,
        state: stateValue,
        country: countryValue,
        phone: values.phone,
        uuid: values.uuid.toString(),
        ptc: values.ptc,
        default:values.default,
        ccnum: values.ccnum??null
      }
    }
    await Axios.post('/profile/location/upsert',val)
    .then(function (response) {
      if (response && response.status == 200 && response.data?.data?.addresses!=null) {
        loadInitialdata();
        cancelEditAddress();
        toast.success('Shipping Address updated successfully.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  };
  toast.configure();
  
  //--------------------------------
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [defaultValue, setDefaultValue] = useState(true);
  const [postValue, setPostValue] = useState('');
  const [addValue, setAddValue] = useState('');

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data?.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    if(result.subgrp?.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
     });
    }
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }
 
  useEffect(() => {
    
    getCountries();
    const permission =AuthVerify.getPermissions("ShippingAddress");
    setViewPermission(permission?.view);
    setEditPermission(permission?.edit);
    setDeletePermission(permission?.delete);
    setAddNewPermission(permission?.addnew);
  }, []);


  useEffect(async () => {
    if(countryValue && defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:countryValue}});
    }
  }, [allCountries,countryValue])

  useEffect(async () => {
    if(stateValue && defaultValue && allStates.length>0){
      handleStateChange({target:{value:stateValue}});
      setDefaultValue(false);
    }
  }, [allStates,stateValue])

  function handlePostalChange(event){
    const postalDiv = event.label.split(' ');
    var postCode="00";
    for (let index = 0; index < postalDiv.length; index++) {
      if(Number(postalDiv[index])>0){
        postCode=postalDiv[index];
      }
    }
    setPostValue(postCode);
    setAddValue(event.value);
  }

  const filterPostalCodes = async (inputValue) => {
    var result = await commonGet(null,`https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=Y&getAddrDetails=Y&pageNum=1`,true);
    var dd=[];
    if(result.data.results && result.data.results.length >0){
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL +"\n"+element.ADDRESS, value:  element.ADDRESS})
    });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if(inputValue.length>1){
        setTimeout(() => {
          resolve(filterPostalCodes(inputValue));
        }, 1000);
      }
  });

  useEffect(async () => {
    if(postValue || addValue){
      window.setPostalCode(postValue ?? addValue);
    }
  }, [addValue])

  return (
    <>
    {
      !addressEditDetails ?
      <>
        <div className="box-account" style={{ display: "grid" }}>
      <div className="page-title">
          <h2 style={{ paddingTop: "12px" , fontSize:"20px"}}>Shipping Addresses</h2>
        </div>
        <div className="header-nav-dropdown-wrapper">
          {
            addressDetails.length>0 && addressDetails.map((item,i)=>{
              return (
                <div key={i} className="jtv-custom-box jtv-custom-box-custom" style={{ width: "25%" }}>
                  <h5 className="heading" style={{ marginBottom: "0",marginBottom:"5px", fontWeight:"bold"}}>
                    Shipping Address {i+1} {deletePermission && <span><i className="fa fa-trash-o" style={{cursor:"pointer",float:"right", fontSize:"17px", padding:"0px", margin:"0 11px 0 0", color:"red"}} onClick={(e)=>{handleDeleteAddress(e,item)}}></i></span>}
                  </h5> 
                  <div className="addressDetails"  onClick={()=>handleEditAddress(`${item.uuid}`,editPermission)} >
                    <p>Location name <b>: {item.dellocname ?? "N/A"}</b></p>
                    <p>Postcode <b>: {item.postcode ?? "N/A"}</b></p>
                    <p>Address 1 <b>: {item.addr1 ?? "N/A"}</b></p>
                    <p>Address 2 <b>: {item.addr2 ?? "N/A"}</b></p>
                    <p>Country <b>: {item.country ?? "N/A"}</b></p>
                    {/* <p>City <b>: {item.city ?? "N/A"}</b></p>
                    <p>State <b>: {item.state ?? "N/A"}</b></p> */}
                    <p>Mobile <b>: {item.phone ?? "N/A"}</b></p>
                  </div>
                  {/* <small style={{ color: "#3c763d" }}>Active</small> */}
                </div>
              );
            })
          }
          {addNewPermission && 
          <div className="jtv-custom-box jtv-custom-box-custom" style={{ width: "25%" }} onClick={()=>handleEditAddress()}>
            <i className="fa fa-plus"></i>
            <h5 className="heading" style={{ marginBottom: "34px" }}>
              Add New Shipping Address
            </h5>
            {/* <small style="color: #3c763d;">Active</small>  */}
            <p></p>
          </div>
          }
        </div>
      </div>
      </>
      :
      <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Shipping Address</h2>
        </div>
        <div className="dashboard">
          <div className="welcome-msg">
            <p>
              Please ensure your details are complete and accurate. Your profile
              details will be used as your default billing information on
              checkout process.
            </p>
          </div>
          <div className="page-content checkout-page">
            <div className="box-border">
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                validate={(values) => {
                  let errors = {};
                  // if (!values.addr1) {
                  //   errors.addr1 = "Required";
                  // }
                  if(addValue==''){
                    errors.addr1 = "Address 1 is required";
                  }
                  else if(addValue.length>49){
                    errors.addr1 = "Address 1 must be at most 50 characters";
                  }
                  if(applycorpsetting && (!values.ccnum || values.ccnum=='')){
                    errors.ccnum = "Cost center is required";
                  }
                  return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  updateFormSubmitHandler(values);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        <Col xl={6} sm={6}>
                          <InputField
                            Name="dellocname"
                            id="dellocname"
                            Labels="Location name"
                            Type="text"
                            value={values.dellocname}
                            onChange={handleChange}
                            isInvalid={!!errors.dellocname}
                            className={(errors.dellocname && touched.dellocname) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>
                          <Col sm={6} xl={6}>
                            <div className="custom_select">
                              <label>Zip / Postal Code</label>
                              <RASelect
                                classNamePrefix="lp-copy-sel customPostalCodeSelect "
                                defaultOptions 
                                cacheOptions 
                                onChange={e=>{handlePostalChange(e); handleChange(e.label);}}
                                onBlur={handleBlur}
                                loadOptions={promiseOptions}
                                className={(errors.postcode && touched.postcode) ? 'is-invalid' : ''}
                              />
                            </div>
                          </Col>
                        </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                      <Row>
                        <Col xl={12} sm={12}>
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="addr1"
                                id="addr1"
                                Labels="Address 1"
                                Type="text"
                                value={addValue}
                                // onChange={handleChange}
                                onChange={e=>{handleChange(e); setAddValue(e.target.value)}}
                                className={(errors.addr1 && touched.addr1) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                        <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr2"
                                  id="addr2"
                                  Labels="Address 2"
                                  Type="text"
                                  value={values.addr2}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr2}
                                  className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                          </Row>
                        </Col>
                        
                        <Col xl={12} sm={12} xs={12}>
                          <Row>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Country"
                                    Name="country"
                                    placeHolder="Select Your Country"
                                    options={countries}
                                    value={values.country}
                                    onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.country && touched.country
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              {/* <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="State/Province"
                                    Type="text"
                                    Name="state"
                                    placeHolder="Select Your State"
                                    options={states}
                                    value={values.state}
                                    onChange={e=>{handleStateChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.state && touched.state
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col> */}
                              </Row>
                          </Col>
                          <Col xl={12} sm={12} xs={12}>
                          <Row>
                          {/* <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="City"
                                    Type="text"
                                    Name="city"
                                    placeHolder="Select Your City"
                                    value={values.city}
                                    onChange={e=>{handleCityChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    options={cities}
                                    className={
                                      errors.city && touched.city
                                        ? " is-invalid"
                                        : ""
                                    }
                                  />
                                </div>
                              </Col> */}
                              <Col sm={6}>
                              <InputField
                                Name="phone"
                                id="phone"
                                Labels="Contact No."
                                Type="text"
                                value={values.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                                className={(errors.phone && touched.phone) ? 'is-invalid' : 'form-control'}
                              />
                              
                            </Col>
                            
                            <Col sm={6}>
                            <InputField
                                Name="ptc"
                                id="ptc"
                                Labels="Contact Person"
                                Type="text"
                                value={values.ptc}
                                onChange={handleChange}
                                isInvalid={!!errors.ptc}
                                className={(errors.ptc && touched.ptc) ? 'is-invalid' : 'form-control'}
                              />
                              </Col>
                              {applycorpsetting && 
                                <Col sm={6}>
                                    <div className="custom_select">
                                      <SlectInputField
                                        Labels="Cost Center"
                                        Type="text"
                                        Name="ccnum"
                                        placeHolder="Select Your Cost Center"
                                        value={values.ccnum}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        options={costCenters}
                                        className={
                                          errors.ccnum && touched.ccnum
                                            ? " is-invalid"
                                            : ""
                                        }
                                      />
                                    </div>
                                </Col>
                              }
                            </Row>
                            <br/>
                              <Col md={12} style={{textAlign:"center"}}>
                                <Field type="checkbox" name="default"/>
                                {"  "}
                                {errors.confirmationBox &&
                                  touched.confirmationBox ? (
                                  <>
                                    <span style={{ color: "red" }}>
                                      {" ! "} {errors.confirmationBox}{" "}
                                    </span>
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                <label>
                                  <span className="button"> </span>
                                  <strong> Set as Default Address</strong>
                                </label>
                              </Col>
                          </Col>

                          <Col xl={12} sm={12}>
                            <button type="submit" className="button">
                              Add / Update Shipping Address
                            </button>
                            <button type="submit" className="button btn-danger" style={{float:"right"}} onClick={()=>cancelEditAddress()}>
                              Cancel
                            </button>
                          </Col>
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
      
    
    </>
  );
};

export default ShippingAddress;
